import { render, staticRenderFns } from "./LearningMediaDisplay.vue?vue&type=template&id=6244d9eb&scoped=true"
import script from "./LearningMediaDisplay.vue?vue&type=script&lang=js"
export * from "./LearningMediaDisplay.vue?vue&type=script&lang=js"
import style0 from "./LearningMediaDisplay.vue?vue&type=style&index=0&id=6244d9eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244d9eb",
  null
  
)

export default component.exports